import type {
  OrgProfile,
  OrgQueue,
  OrgUser,
  OwnerMode,
  ReassignMode,
  SegmentOption,
  UserAccess,
} from '../types/offboarding'

export const profiles: OrgProfile[] = [
  { id: 'inside-lo', name: 'Active Link - Inside Loan Officer' },
  { id: 'outside-lo', name: 'Active Link - Outside Loan Officer' },
  { id: 'processor', name: 'Active Link - Processor' },
]

export const queues: OrgQueue[] = [
  { id: 'borrower-queue', name: 'Borrower Queue', object: 'ACCOUNT' },
  { id: 'account-queue', name: 'Account Queue', object: 'ACCOUNT' },
  { id: 'lead-queue', name: 'Lead Queue', object: 'LEAD' },
  { id: 'inside-lo-lead-queue', name: 'Inside LO Lead Queue', object: 'LEAD' },
  { id: 'nurture-lead-queue', name: 'Nurture Lead Queue', object: 'LEAD' },
]

export const ownerModeOptions: SegmentOption<OwnerMode>[] = [
  { value: 'ALL_INACTIVE', label: 'All inactive owners' },
  { value: 'PICK_INACTIVE', label: 'Select through inactive' },
  { value: 'PICK_ANY', label: 'Select through all users' },
]

export const reassignModeOptions: SegmentOption<ReassignMode>[] = [
  { value: 'USERS', label: 'Distribute to Active Users' },
  { value: 'USERS_BY_PROFILE', label: 'Distribute to Active Users by Profile' },
  { value: 'QUEUE', label: 'Send to Queue' },
]

export const orgUsers: OrgUser[] = [
  // Inactive / departing owners — 142 Person Accounts, 38 Leads in total
  { id: 'jacob-ferry', name: 'Jacob Ferry', email: 'jacobferry@activelinkmortgage.com', active: false, profileId: 'inside-lo', personAccounts: 64, leads: 17 },
  { id: 'sunny-kim', name: 'Sunny Kim', email: 'sunnykim@activelinkmortgage.com', active: false, profileId: 'inside-lo', personAccounts: 41, leads: 12 },
  { id: 'derek-lawson', name: 'Derek Lawson', email: 'dereklawson@activelinkmortgage.com', active: false, profileId: 'outside-lo', personAccounts: 12, leads: 3 },
  { id: 'priya-natarajan', name: 'Priya Natarajan', email: 'priyanatarajan@activelinkmortgage.com', active: false, profileId: 'inside-lo', personAccounts: 9, leads: 2 },
  { id: 'carlos-mendes', name: 'Carlos Mendes', email: 'carlosmendes@activelinkmortgage.com', active: false, profileId: 'processor', personAccounts: 7, leads: 4 },
  { id: 'hannah-brooks', name: 'Hannah Brooks', email: 'hannahbrooks@activelinkmortgage.com', active: false, profileId: 'inside-lo', personAccounts: 5, leads: 0 },
  { id: 'tom-albrecht', name: 'Tom Albrecht', email: 'tomalbrecht@activelinkmortgage.com', active: false, profileId: 'outside-lo', personAccounts: 3, leads: 0 },
  { id: 'nina-ostrowski', name: 'Nina Ostrowski', email: 'ninaostrowski@activelinkmortgage.com', active: false, profileId: 'inside-lo', personAccounts: 1, leads: 0 },

  // Active Inside Loan Officers (20)
  { id: 'matthew-campbell', name: 'Matthew Campbell', email: 'matthewcampbell@activelinkmortgage.com', active: true, profileId: 'inside-lo', personAccounts: 58, leads: 21 },
  { id: 'azin-gerayeli', name: 'Azin Gerayeli', email: 'azingerayeli@activelinkmortgage.com', active: true, profileId: 'inside-lo', personAccounts: 47, leads: 16 },
  { id: 'brenda-rector', name: 'Brenda Rector', email: 'brendarector@activelinkmortgage.com', active: true, profileId: 'inside-lo', personAccounts: 52, leads: 19 },
  { id: 'andre-coleman', name: 'Andre Coleman', email: 'andrecoleman@activelinkmortgage.com', active: true, profileId: 'inside-lo', personAccounts: 39, leads: 11 },
  { id: 'bianca-torres', name: 'Bianca Torres', email: 'biancatorres@activelinkmortgage.com', active: true, profileId: 'inside-lo', personAccounts: 44, leads: 14 },
  { id: 'caleb-hughes', name: 'Caleb Hughes', email: 'calebhughes@activelinkmortgage.com', active: true, profileId: 'inside-lo', personAccounts: 36, leads: 9 },
  { id: 'danielle-price', name: 'Danielle Price', email: 'danielleprice@activelinkmortgage.com', active: true, profileId: 'inside-lo', personAccounts: 41, leads: 13 },
  { id: 'elijah-foster', name: 'Elijah Foster', email: 'elijahfoster@activelinkmortgage.com', active: true, profileId: 'inside-lo', personAccounts: 33, leads: 8 },
  { id: 'fiona-nguyen', name: 'Fiona Nguyen', email: 'fionanguyen@activelinkmortgage.com', active: true, profileId: 'inside-lo', personAccounts: 49, leads: 17 },
  { id: 'gavin-ortiz', name: 'Gavin Ortiz', email: 'gavinortiz@activelinkmortgage.com', active: true, profileId: 'inside-lo', personAccounts: 28, leads: 7 },
  { id: 'heather-lin', name: 'Heather Lin', email: 'heatherlin@activelinkmortgage.com', active: true, profileId: 'inside-lo', personAccounts: 45, leads: 12 },
  { id: 'isaac-patel', name: 'Isaac Patel', email: 'isaacpatel@activelinkmortgage.com', active: true, profileId: 'inside-lo', personAccounts: 31, leads: 10 },
  { id: 'jasmine-reed', name: 'Jasmine Reed', email: 'jasminereed@activelinkmortgage.com', active: true, profileId: 'inside-lo', personAccounts: 38, leads: 12 },
  { id: 'kevin-morales', name: 'Kevin Morales', email: 'kevinmorales@activelinkmortgage.com', active: true, profileId: 'inside-lo', personAccounts: 42, leads: 15 },
  { id: 'lauren-scott', name: 'Lauren Scott', email: 'laurenscott@activelinkmortgage.com', active: true, profileId: 'inside-lo', personAccounts: 35, leads: 9 },
  { id: 'marco-deluca', name: 'Marco DeLuca', email: 'marcodeluca@activelinkmortgage.com', active: true, profileId: 'inside-lo', personAccounts: 29, leads: 6 },
  { id: 'natalie-brooks', name: 'Natalie Brooks', email: 'nataliebrooks@activelinkmortgage.com', active: true, profileId: 'inside-lo', personAccounts: 46, leads: 18 },
  { id: 'omar-haddad', name: 'Omar Haddad', email: 'omarhaddad@activelinkmortgage.com', active: true, profileId: 'inside-lo', personAccounts: 37, leads: 11 },
  { id: 'paige-sullivan', name: 'Paige Sullivan', email: 'paigesullivan@activelinkmortgage.com', active: true, profileId: 'inside-lo', personAccounts: 40, leads: 13 },
  { id: 'ryan-whitaker', name: 'Ryan Whitaker', email: 'ryanwhitaker@activelinkmortgage.com', active: true, profileId: 'inside-lo', personAccounts: 34, leads: 10 },

  // Active Outside Loan Officers
  { id: 'samuel-grant', name: 'Samuel Grant', email: 'samuelgrant@activelinkmortgage.com', active: true, profileId: 'outside-lo', personAccounts: 61, leads: 8 },
  { id: 'tessa-monroe', name: 'Tessa Monroe', email: 'tessamonroe@activelinkmortgage.com', active: true, profileId: 'outside-lo', personAccounts: 54, leads: 6 },
  { id: 'victor-alvarez', name: 'Victor Alvarez', email: 'victoralvarez@activelinkmortgage.com', active: true, profileId: 'outside-lo', personAccounts: 48, leads: 5 },
  { id: 'whitney-cole', name: 'Whitney Cole', email: 'whitneycole@activelinkmortgage.com', active: true, profileId: 'outside-lo', personAccounts: 57, leads: 9 },
  { id: 'xavier-bell', name: 'Xavier Bell', email: 'xavierbell@activelinkmortgage.com', active: true, profileId: 'outside-lo', personAccounts: 43, leads: 4 },
  { id: 'yvonne-park', name: 'Yvonne Park', email: 'yvonnepark@activelinkmortgage.com', active: true, profileId: 'outside-lo', personAccounts: 50, leads: 7 },
  { id: 'kyle-dunn', name: 'Kyle Dunn', email: 'kyledunn@activelinkmortgage.com', active: true, profileId: 'outside-lo', personAccounts: 0, leads: 0 },

  // Active Processors
  { id: 'zoe-kendall', name: 'Zoe Kendall', email: 'zoekendall@activelinkmortgage.com', active: true, profileId: 'processor', personAccounts: 22, leads: 0 },
  { id: 'liam-carter', name: 'Liam Carter', email: 'liamcarter@activelinkmortgage.com', active: true, profileId: 'processor', personAccounts: 18, leads: 0 },
  { id: 'mia-rossi', name: 'Mia Rossi', email: 'miarossi@activelinkmortgage.com', active: true, profileId: 'processor', personAccounts: 25, leads: 1 },
  { id: 'noah-jensen', name: 'Noah Jensen', email: 'noahjensen@activelinkmortgage.com', active: true, profileId: 'processor', personAccounts: 19, leads: 0 },

  // Backend-excluded from target lists (non-production accounts)
  { id: 'training-user', name: 'Training User', email: 'training@activelinkmortgage.com', active: true, profileId: 'inside-lo', personAccounts: 0, leads: 0, excludedFromTargets: true },
  { id: 'nimbus-development', name: 'Nimbus Development', email: 'dev@nimbus-activelink.com', active: true, profileId: 'processor', personAccounts: 0, leads: 0, excludedFromTargets: true },
]

/** Licenses and permission sets currently assigned, by profile. */
export const accessByProfile: Record<string, UserAccess> = {
  'inside-lo': {
    licenses: [
      { id: 'sf', name: 'Salesforce', detail: 'Sales Cloud user license' },
      { id: 'pulse', name: 'Pulse', detail: 'Pulse Technology package' },
      { id: 'mpcrm', name: 'Mortgage Planner CRM', detail: 'Managed package license' },
      { id: 'bonzo', name: 'Bonzo', detail: 'Dialer & texting seat' },
    ],
    permissionSets: [
      { id: 'sales-user', name: 'Sales User', detail: 'Base CRM access' },
      { id: 'lo-ps', name: 'Loan Officer Permission Set', detail: 'Pipeline & pricing' },
      { id: 'eac', name: 'Einstein Activity Capture', detail: 'Email & calendar sync' },
      { id: 'lendingpad', name: 'LendingPad Integration', detail: 'LOS sync' },
      { id: 'ringcentral', name: 'RingCentral for Salesforce', detail: 'Telephony' },
      { id: 'enhanced-notes', name: 'Enhanced Notes', detail: 'Notes access' },
    ],
  },
  'outside-lo': {
    licenses: [
      { id: 'sf', name: 'Salesforce', detail: 'Sales Cloud user license' },
      { id: 'pulse', name: 'Pulse', detail: 'Pulse Technology package' },
      { id: 'mpcrm', name: 'Mortgage Planner CRM', detail: 'Managed package license' },
    ],
    permissionSets: [
      { id: 'sales-user', name: 'Sales User', detail: 'Base CRM access' },
      { id: 'lo-ps', name: 'Loan Officer Permission Set', detail: 'Pipeline & pricing' },
      { id: 'eac', name: 'Einstein Activity Capture', detail: 'Email & calendar sync' },
      { id: 'lendingpad', name: 'LendingPad Integration', detail: 'LOS sync' },
    ],
  },
  processor: {
    licenses: [
      { id: 'sf', name: 'Salesforce', detail: 'Sales Cloud user license' },
      { id: 'pulse', name: 'Pulse', detail: 'Pulse Technology package' },
    ],
    permissionSets: [
      { id: 'sales-user', name: 'Sales User', detail: 'Base CRM access' },
      { id: 'processor-ps', name: 'Processor Permission Set', detail: 'Loan file access' },
      { id: 'lendingpad', name: 'LendingPad Integration', detail: 'LOS sync' },
      { id: 'enhanced-notes', name: 'Enhanced Notes', detail: 'Notes access' },
    ],
  },
}

/** The departing user passed in by the termination Screen Flow. */
export const flowDepartingUserId = 'sunny-kim'
